// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import React from 'react';
import Button from 'components/primitive/Button';

import { LogoLogin, ErrorIcon } from 'assets';
import { useTranslation } from 'react-i18next';

import * as S from './styled';

export default function Fallback({ title }) {
  const { t } = useTranslation();

  return (
    <S.Container>
      <LogoLogin className="top-logo" />
      <ErrorIcon className="error-icon" />
      <S.Message>{t(title)}</S.Message>
      <Button
        color="white"
        radius="large"
        gradient="gradient9"
        background="gradient9"
        className="button"
        width={180}
        height={40}
        onClick={() => window.location.replace('/')}
      >
        {t('global.button.to_home')}
      </Button>
    </S.Container>
  );
}
